'use client'

import { useEffect } from "react"
import ApiUtils from "@/utils/ApiUtils"

export default function TrackingPixel(props) {

  useEffect(() => {
    ApiUtils.logEvent({ 
      url: window.location.href,
      campaign: props.searchParams,
      site: props.site.site_id
    })
  }, [])
  
  return <></>
  
}